/*
 * Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 * Written by Dominik Lippl <dl@venus.bayern>
 */

import { defineStore } from "pinia";
import Axios from "@auth/vue-share/utility/axios";

export const useScopesStore = defineStore({
  id: "scopes",
  state: () => ({
    scopes: undefined
  }),
  getters: {
    getScopes: (state) => state.scopes
  },
  actions: {
    fetchScopes() {
      Axios.get("scope/scopes", "/api/scopes").then((response) => {
        this.scopes = response.data.data;
      });
    },
    async getScope(identifier) {
      return Axios.get("scopes/scope", `/api/scopes/${identifier}`);
    },
    async createScope(scope) {
      return Axios.post("scopes/scope", "/api/scopes", scope);
    },
    updateScope(scope) {
      return Axios.patch("scopes/scope", `/api/scopes`, scope);
    },
    deleteScope(scope_identifier) {
      return new Promise((resolve, reject) => {
        Axios.delete("scopes/delete", `/api/scopes/${scope_identifier}`).then(() => {
          const index = this.scopes.findIndex((scope) => scope.identifier === scope_identifier);

          if (index !== -1)
            this.scopes.splice(index, 1);

          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    }
  }
});
